import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
const SupportResources = () => {
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const cardStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2rem',
    padding: '2rem',
    justifyContent: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
  };

  const resourceCardStyle = {
    flex: '1 1 300px',
    maxWidth: '350px',
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '2rem',
    textAlign: 'center',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const imageStyle = {
    width: '100%',
    height: '200px',
    objectFit: 'cover',
    borderRadius: '4px',
    marginBottom: '1.5rem',
  };

  const titleStyle = {
    fontSize: '32px',
    fontFamily: '"Oswald", sans-serif',
    color: '#410684',
    lineHeight: '40px',
    fontWeight: '500',
    marginBottom: '1rem',
    textTransform: 'uppercase',
  };

  const descriptionStyle = {
    color: 'rgb(65, 64, 66)',
    fontSize: '1rem',
    lineHeight: '1.5',
    marginBottom: '1.5rem',
  };

  const styles = {
    heading: {
      fontFamily: 'Oswald, sans-serif',
      fontSize: '60px',
      color: '#410684',
      lineHeight: '22px',
      textAlign: 'center',
      letterSpacing: '2px',
    },
    container: {
      padding: '2rem 0',
    },
  };

  const buttonStyle = {
    backgroundColor: '#410684', // Purple color for buttons
    color: 'white',
    padding: '0.75rem 2rem',
    borderRadius: '4px',
    fontFamily: 'Oswald, sans-serif',
    border: 'none',
    fontSize: '18px',
    lineHeight: '20px',
    fontWeight: '500',
    cursor: 'pointer',
    textDecoration: 'none',
  };

  return (
    <div ref={containerRef} style={styles.container}>
      <h2 style={styles.heading}>OUR PRODUCT RANGE</h2>
      <div style={cardStyle}>
        <div style={resourceCardStyle}>
          <img 
            src="/product_router.jpg"
            alt="Complete Product Line"
            style={imageStyle}
          />
          <h2 style={titleStyle}>COMPLETE PRODUCT LINE</h2>
          <p style={descriptionStyle}>
          Explore our full range of products, delivering quality and innovation to enhance your business.
          </p>
          <button style={buttonStyle}
           onClick={() => navigate('/product')}>EXPLORE NOW</button>
        </div>

        <div style={resourceCardStyle}>
          <img 
            src="/consult4.jpg"
            alt="Expert Consultation Services"
            style={imageStyle}
          />
          <h2 style={titleStyle}>EXPERT CONSULTATION SERVICES</h2>
          <p style={descriptionStyle}>
          Get specialized advice from our consultants, tailored to your business challenges and goals.
          </p>
          <button style={buttonStyle}
             onClick={() => navigate('/services')}>LEARN MORE</button>
        </div>

        <div style={resourceCardStyle}>
          <img 
            src="/router2.jpg"
            alt="IT & Infrastructure Solutions"
            style={imageStyle}
          />
          <h2 style={titleStyle}>IT & INFRASTRUCTURE SOLUTIONS</h2>
          <p style={descriptionStyle}>
          Discover comprehensive IT and infrastructure services, crafted to secure your digital environment.
          </p>
          <button style={buttonStyle}
             onClick={() => navigate('/solution')}>DISCOVER</button>
        </div>
      </div>
    </div>
  );
};

export default SupportResources;
